'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _isIterable2 = require('babel-runtime/core-js/is-iterable');

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabManager = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if ((0, _isIterable3.default)(Object(arr))) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _MessageChannel = require('./MessageChannel');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new _promise2.default(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return _promise2.default.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var TabManager = exports.TabManager = function TabManager(_ref) {
  var type = _ref.type,
      channelName = _ref.channelName,
      fallbackInterval = _ref.fallbackInterval,
      responseTime = _ref.responseTime,
      emitOnAllTabs = _ref.emitOnAllTabs,
      callbacks = _ref.callbacks,
      start = _ref.start,
      reset = _ref.reset,
      pause = _ref.pause,
      resume = _ref.resume;

  var channel = new _MessageChannel.MessageChannel(channelName, { type: type });
  var elector = (0, _MessageChannel.createLeaderElection)(channel, {
    fallbackInterval: fallbackInterval,
    responseTime: responseTime
  });
  var registry = {};

  // Register self
  registry[elector.token] = false;

  var leader = false;
  var allIdle = true;

  var isLeader = function isLeader() {
    return leader;
  };

  elector.awaitLeadership().then(function () {
    leader = true;
  });

  channel.addEventListener('message', function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        type = _ref3[0],
        id = _ref3[1];

    switch (type) {
      case 'register':
        registry[id] = false;
        break;
      case 'deregister':
        delete registry[id];
        break;
      case 'idle':
        idle(id);
        break;
      case 'active':
        active(id);
        break;
      case 'emitIdle':
        callbacks.onIdle();
        break;
      case 'emitActive':
        callbacks.onActive();
        break;
      case 'start':
        start(true);
        break;
      case 'reset':
        reset(true);
        break;
      case 'pause':
        pause(true);
        break;
      case 'resume':
        resume(true);
        break;
      default:
      // no op
    }
  });

  var setAllIdle = function setAllIdle(bool) {
    allIdle = bool;
  };

  var isAllIdle = function isAllIdle() {
    return allIdle;
  };

  var idle = function idle() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : elector.token;

    registry[id] = true;
    var isIdle = (0, _values2.default)(registry).every(function (v) {
      return v;
    });
    if (!allIdle && isIdle) {
      allIdle = true;
      if (isLeader()) {
        callbacks.onIdle();
        if (emitOnAllTabs) send('emitIdle');
      } else {
        send('idle');
      }
    }
  };

  var active = function active() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : elector.token;

    registry[id] = false;
    var isActive = (0, _values2.default)(registry).some(function (v) {
      return !v;
    });
    if (allIdle && isActive) {
      allIdle = false;
      if (isLeader()) {
        callbacks.onActive();
        if (emitOnAllTabs) send('emitActive');
      } else {
        send('active');
      }
    }
  };

  /* istanbul ignore next */
  elector.onDuplicate = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return elector.die();

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));
  elector.onBeforeDie = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return send('deregister');

          case 2:
            return _context2.abrupt('return', _context2.sent);

          case 3:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  var send = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee3(message) {
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', channel.postMessage([message, elector.token]));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, undefined);
    }));

    return function send(_x3) {
      return _ref6.apply(this, arguments);
    };
  }();

  var close = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
      return _regenerator2.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return elector.die();

            case 2:
              _context4.next = 4;
              return channel.close();

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, undefined);
    }));

    return function close() {
      return _ref7.apply(this, arguments);
    };
  }();

  // Register self with remote tabs
  send('register');

  return { close: close, send: send, isLeader: isLeader, idle: idle, active: active, isAllIdle: isAllIdle, setAllIdle: setAllIdle };
};